// extracted by mini-css-extract-plugin
export default {"container":"styles_container__tU+nz","button":"styles_button__OdfUa","text":"styles_text__ywvMI","icon":"styles_icon__7HHyP"};